export const updateTask = (payload?: any) => ({
    type: "@saga/UPDATE_TASK",
    payload
});

